<template>
  <div class="text-input">
    <label>
      <span ref="labelName">
        {{label}}
        <!-- <span v-if="data.required" style="color:red;">*</span>  -->
      </span>
      <input
        v-model="_value"
        @input="changeValue"
        :type="type"
        :placeholder="label"
        :autocomplete="autocomplete ? 'on' : 'off'"
        :required="required ? true : false"
        :maxlength="maxlength"
        :minlength="minlength"
        :min="min"
        :disabled="disabled"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'text-input',
  props : {
    type : {
      required : true,
    },
    value : {
      required : true,
      default : null,
    },
    label : {
      required: true
    },
    required : {
      required : false,
      default : false,
    },
    autocomplete : {
      required : false,
      default : false
    },
    minlength : {
      required : false
    },
    maxlength : {
      required : false,
      default : 50,
    },
    placeholder : {
      required : false
    },
    min: {
      required : false,
    },
    disabled: {
      required : false,
      default : false,
    }
  },
  data() {
    return {
      _value : null,
    }
  },
  created() {
    this._value = this.value;

  },
  methods : {
    changeValue() {
      this.$emit('input',this._value);
      if(this._value.length > 0) {
        this.$refs.labelName.style.opacity = 1;
      }else {
        this.$refs.labelName.style.opacity = 0;
      }
    },
  },
  mounted() {
    if(this._value) {
      this.$refs.labelName.style.opacity = 1;
    }
  }
}
</script>

<style lang="scss" scoped>

.text-input {
  width:100%;
  margin-bottom: 24px;
  // margin-top: 16px;
  label {
    font-size:12px;
    position: relative;
    > span {
      text-transform: capitalize;
      opacity: .0;
      color: #4C5056;
      transition: .3s;
      position: absolute;
      top: calc(-100% - 18px);
      pointer-events: none;
      padding-left: 1px;
    }
    input {
      width: 100%;
      // border-width:0px;
      // border-style: solid;
      padding:8px 12px 8px 12px;
      background-color: #fff;
      border: 1px solid $mainGreen;
      border-radius: 3px;
      outline: none;
      color: $mainGreen;
      font-size:16px;
      height: 42px;
      &::placeholder {
        text-transform: capitalize;
        font-size:16px;
        opacity: .65;
        color:#333;
      }
    }
  }
}
</style>
